import React, { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { initialTabs as services } from "./data";

const Window = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: white;
  overflow: hidden;
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
  display: flex;
  flex-direction: column;
`;

const Nav = styled.nav`
  background: #fdfdfd;
  padding: 5px 5px 0;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid #eeeeee;
  width: 100%;
  overflow-x: auto; /* Permite scroll horizontal en pantallas pequeñas */
`;

const Tabs = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  flex-direction: row;
  align-content: stretch;
  align-items: flex-start;
  justify-content: space-evenly; /* Distribuye los tabs uniformemente */
`;

const Tab = styled.li<{ selected: boolean }>`
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 10px 15px;
  background: ${({ selected }) => (selected ? "#eee" : "white")};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px; /* Asegura que los tabs tengan un ancho mínimo */
  user-select: none;
  font-size: 1rem;
  white-space: nowrap;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 5px 10px;
    justify-content: center;
  }
`;

const Underline = styled(motion.div)`
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: #8855ff;
`;

const MainContent = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  user-select: none;
  width: 100%;
  padding: 20px;
  overflow: hidden; /* Ocultar el scroll */
`;

const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  
  &::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
`;

const AboutUs: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(services[0]);

  return (
    <Window>
      <Nav>
        <Tabs>
          {services.map((service) => (
            <Tab
              key={service.label}
              selected={service === selectedTab}
              onClick={() => setSelectedTab(service)}
            >
              {`${service.icon} ${service.label}`}
              {service === selectedTab ? (
                <Underline layoutId="underline" />
              ) : null}
            </Tab>
          ))}
        </Tabs>
      </Nav>
      <MainContent>
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedTab ? selectedTab.label : "empty"}
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ScrollContainer>
              <ImageContainer>
                <Image src={selectedTab.image} alt={selectedTab.label} loading="lazy" />
              </ImageContainer>
            </ScrollContainer>
          </motion.div>
        </AnimatePresence>
      </MainContent>
    </Window>
  );
};

export default AboutUs;
